import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import StyledText from "./StyledText";
import EditIcon from "../../assets/svgIcons/EditIcon";
import CheckIcon from "../../assets/svgIcons/CheckIcon";
import { validateEmail, validatePhone } from "../../utils/helper";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
`;

const InputField = styled.input`
  border: none;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 400;
  outline: none;
  background: none;
  margin: 0 0.87rem;
  flex-grow: 1;
  animation: ${({ visible }) => (visible ? fadeIn : fadeOut)} 0.3s ease forwards;
  border-bottom: ${({ error }) =>
    error ? "1px solid red" : "none"}; /* Add red border if there is an error */
`;

const StyledEditableText = ({
  text = "",
  type = "text",
  objKey = "",
  onChange,
  isEditable = true,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);
  const [error, setError] = useState(false); // Error state
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    setError(false); // Reset error state when input value changes
  };

  const handleKeyPress = (e, isDone) => {
    if (e.key === "Enter" || isDone === "done") {
      if (type === "email" && !validateEmail(value)) {
        setError(true); // Set error state if email is invalid
      } else if (type === "phone" && !validatePhone(value)) {
        setError(true); // Set error state if phone is invalid
      } else {
        e.preventDefault();
        setIsEditing(false);

        onChange({ value, objKey });
      }
    }
  };

  return (
    <Wrapper>
      {isEditing && isEditable ? (
        <>
          <InputField
            type={type}
            className="flex-grow-1"
            value={value}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            visible={isEditing ? 1 : 0}
            ref={inputRef}
            error={error} // Pass error state to input field
          />
          <CheckIcon
            onClick={(e) => handleKeyPress(e, "done")}
            style={{ cursor: "pointer", opacity: isEditing ? 1 : 0 }}
          />
        </>
      ) : (
        <>
          <StyledText
            onDoubleClick={isEditable ? handleDoubleClick : () => {}}
            $fontSize="0.9rem"
            className="ms-3 user-name flex-grow-1"
            style={{ opacity: isEditing ? 0 : 1 }}
          >
            {value || "-"}
          </StyledText>
          {isEditable && (
            <span
              className="cursor-pointer"
              onClick={handleDoubleClick}
              style={{ opacity: isEditing ? 0 : 1 }}
            >
              <EditIcon style={{ cursor: "pointer" }} />
            </span>
          )}
        </>
      )}
    </Wrapper>
  );
};

export default StyledEditableText;
